import {Box} from '@mui/material';
import React from 'react';
import {ITabFilter} from '@wearesection/bandai-react-components/organisms/EStoreProduct/TabFilter';
import {usePageSetting} from '~/providers/page-context.provider';
import {useSelector} from 'react-redux';
import EStoreMerchandiseListing from '@wearesection/bandai-react-components/organisms/EStoreMerchandiseListing';
import {IProductItem} from '@wearesection/bandai-react-components/organisms/EStoreProduct/ProductItem';
import {TypeDataFilter} from '@wearesection/bandai-react-components/organisms/ScrollingFilterListing';
import {ListingType} from '@wearesection/bandai-react-components/molecules/FilterSelectionListing';
import {cloneDeep} from 'lodash';
import {GetRouter} from '~/utils';

type IEStoreMerchandiseOrganisms = {
  hasNextPage: boolean;
  typeTabFilter: ITabFilter;
  onLoadMore: () => void;
  onlSelectTab: (v: string, callback: () => void) => void;
  onFilter: (filter: any, sort: any, callback?: () => void) => void;
  isEmptyData: boolean;
  productList: IProductItem[];
};

function EStoreMerchandiseOrganisms(props: IEStoreMerchandiseOrganisms) {
  const {hasNextPage, onLoadMore, onlSelectTab, onFilter, typeTabFilter, isEmptyData, productList} =
    props;
  const {locale} = GetRouter();
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const tabSelect: any = useSelector(
    (state: any) => state?.merchandise?.tabSelect || typeTabFilter.tabList?.[0]?.value
  );

  const dataFilter: TypeDataFilter[] = useSelector(
    (state: any) => state?.merchandise?.dataFilter || []
  );

  const sortBy: ListingType[] = useSelector((state: any) => state?.merchandise?.sortBy || []);
  const sortItem: string = useSelector((state: any) => state?.merchandise?.sortItem || '');
  const filterItem: any = useSelector((state: any) => state?.merchandise?.filterItem || {});

  const dataEmpty = {
    title: dataTranslation?.['estore-title-empty-listing'] || 'You have ventured into empty space',
    description:
      dataTranslation?.['estore-description-empty-listing'] ||
      'Try other filter options to continue shopping.',
    iconNotFound:
      'https://images.ctfassets.net/hnoi7ctzfs57/6ITH9fmyysAbuvwk6W0QKP/ee0b0c4f9d80a148c4464cd65d180509/No_searching_result.svg',
  };

  const handleFormatSortBy = (sortData: ListingType[]) => {
    const newDataSort = cloneDeep(sortData);
    return newDataSort.map(item => {
      if (item.name === sortItem) {
        return {
          ...item,
          isChecked: true,
        };
      }
      return item;
    });
  };

  const handleFormatFilter = (dataFilter: TypeDataFilter[]) => {
    const newDataFilter = cloneDeep(dataFilter);
    if (!Object.keys(filterItem)?.length) {
      return newDataFilter;
    }
    return dataFilter.map(item => {
      const key = item.value || '';
      if (filterItem[key]) {
        let count = 0;
        return {
          ...item,
          dataFilter: item.dataFilter.map(itemSub => {
            if (
              filterItem[key]?.includes(JSON.stringify(itemSub.name)) ||
              filterItem[key]?.includes(itemSub.name) ||
              JSON.stringify(filterItem[key][0]) === JSON.stringify(itemSub.name)
            ) {
              count += 1;
              return {
                ...itemSub,
                isChecked: true,
              };
            }

            return itemSub;
          }),
          countSelect: count,
        };
      }
      return item;
    });
  };

  const handleCheckActivePillDefault = (): boolean => {
    let result = false;
    for (const value of Object.values(filterItem)) {
      if (Array.isArray(value) && value?.length) {
        result = true;
        break;
      }
      if (typeof value === 'object' && Object.values(value as any)?.length) {
        result = true;
        break;
      }
    }

    return result;
  };

  const handleRenderLengthFilter = () => {
    let result = 0;
    if (Object.keys(filterItem)?.length) {
      for (const value of Object.values(filterItem)) {
        result += (value as []).length || 0;
      }
    }
    return result;
  };

  return (
    <Box>
      <EStoreMerchandiseListing
        onFilter={onFilter}
        tabSelect={tabSelect * 1}
        typeTabFilter={typeTabFilter}
        sortByText={dataTranslation['filter-game-sort-by']}
        filterByText={dataFilter?.length ? dataTranslation['filter-game-filter-by'] : ''}
        showMoreText={dataTranslation['filter-game-show-more']}
        showLessText={dataTranslation['filter-game-show-less']}
        onLoadMore={onLoadMore}
        onSelectTab={onlSelectTab}
        hadLoadMore={hasNextPage}
        productList={productList}
        dataFilter={cloneDeep(handleFormatFilter(dataFilter))}
        sortBy={cloneDeep(handleFormatSortBy(sortBy))}
        buttonPropsDone={{
          variant: 'primaryDark',
          label: dataTranslation['filter-game-done'],
          disabled: false,
        }}
        buttonPropsClear={{
          variant: 'secondary',
          label: dataTranslation['filter-game-clear'],
          disabled: false,
        }}
        activePillDefault={handleCheckActivePillDefault()}
        isEmptyData={isEmptyData}
        dataEmpty={dataEmpty}
        lengthFilter={handleRenderLengthFilter()}
        locale={`${locale}`.toLowerCase()}
      />
    </Box>
  );
}

export default EStoreMerchandiseOrganisms;
